// @ts-strict-ignore
import React, { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';

import { HeroSearch } from 'api/cms';
import { PublicPage } from 'api/website';
import { Box } from 'components/Box';
import HideContainer from 'containers/HideContainer';
import { NoAmp } from 'containers/NoAmp';
import { shadows } from 'theme';
import { isDefined } from 'utils/functional';

import { FixedLayoutStaffTools } from './FixedLayoutStaffTools';
import { LayoutSearchMenu } from './LayoutSearchMenu';
import { LayoutStaffTools } from './LayoutStaffTools';

const StyledStickyBox = styled(Box)`
  transform: translateZ(0);
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
`;

type Props = {
  content: PublicPage | undefined;
  hero: HeroSearch | undefined;
  searchMode: boolean;
  renderWithSearchHero: boolean;
  postSearchToolbar: ReactNode | undefined;
  onSearch: () => void;
  navSection: 'MAIN' | 'STAFF' | undefined;
  defaultSearchType: DefaultSearchType | undefined;
};

export function LayoutContentToolbar({
  content,
  hero,
  searchMode,
  renderWithSearchHero,
  postSearchToolbar,
  onSearch,
  navSection,
  defaultSearchType,
}: Props): ReactElement {
  const withWrappers = (!hero || searchMode) && !renderWithSearchHero;

  if (!withWrappers) {
    return content ? <FixedLayoutStaffTools content={content} /> : null;
  }

  if (isDefined(postSearchToolbar)) {
    return (
      <NoAmp>
        <HideContainer xs sm md position="relative" zIndex="101">
          <LayoutSearchMenu
            onSearch={onSearch}
            searchMode={Boolean(searchMode)}
            navSection={navSection}
            defaultSearchType={defaultSearchType}
          />
        </HideContainer>

        <Box
          component={StyledStickyBox}
          display={['none', null, null, 'block']}
        >
          {postSearchToolbar}
          {content && <LayoutStaffTools content={content} />}
        </Box>

        <Box height={75} display={['block', null, null, 'none']}>
          <Box position="fixed" top={60} left={0} width={1} zIndex={101}>
            {postSearchToolbar}
            {content && <LayoutStaffTools content={content} />}
          </Box>
        </Box>
      </NoAmp>
    );
  }

  return (
    <NoAmp>
      {content && <FixedLayoutStaffTools content={content} />}
      <StyledStickyBox>
        <Box
          boxShadow={shadows.toolbar}
          display={['none', null, null, 'block']}
        >
          <LayoutSearchMenu
            onSearch={onSearch}
            searchMode={Boolean(searchMode)}
            navSection={navSection}
            defaultSearchType={defaultSearchType}
          />
        </Box>
      </StyledStickyBox>
    </NoAmp>
  );
}
